export const FEATURE_NAME = '@zerops/zerops/common/billing-info-form';
